import {BoardObjectTags} from '../enums/BoardObjectTags.js';
import {GameModeType} from '../enums/GameModeType.js';
import {PieceSpawnRules} from './PieceSpawnRules.js';

/**
 * Return the rules for spawning pieces for a specific game mode.
 *
 * In the original game this was defined in the editor. But due to some limitation of
 * WonderlandEngine we have to define it in code.
 */
export class GameModePieceSpawnRules {
    private static _instance: GameModePieceSpawnRules;
    static get instance(): GameModePieceSpawnRules {
        if (!GameModePieceSpawnRules._instance) {
            GameModePieceSpawnRules._instance = new GameModePieceSpawnRules();
        }
        return GameModePieceSpawnRules._instance;
    }

    getRules(gameMode: GameModeType): PieceSpawnRules[] {
        let rules: PieceSpawnRules[] = [];
        switch (gameMode) {
            case GameModeType.Normal:
            case GameModeType.Timed:
            case GameModeType.Survival:
            case GameModeType.Tutorial:
            case GameModeType.Easy:
            case GameModeType.Zen:
            case GameModeType.Quickplay:
            case GameModeType.Fungus:
            case GameModeType.Cupcake:
                // rules will differ for different modes.
                // Until these are implemented, we just return coins.
                const coinRules = new PieceSpawnRules({
                    objectsToSpawn: [
                        {
                            minimumLevelToSpawn: 0,
                            piece: 'Preloaded Coin',
                            tag: BoardObjectTags[BoardObjectTags.Coin],
                        },
                    ],
                    idealCountInStack: 5,
                    idealCountPerRow: 0,
                    maximumPerRow: 5,
                    minimumLevelToSpawn: 0,
                    spawnMoreAfterSomeRows: true,
                    newRowsBeforeSpawning: 1,
                    newRowMinAddition: 0,
                    newRowMaxAddition: 2,
                    spawnMoreWhenTimeIsRunningOut: false,
                    timeRunningOutSeconds: 0,
                    timeRunningOutCountPerRow: 0,
                    considerRandomVariance: true,
                    modifierAtMinVariance: -0.5,
                    modifierAtMaxVariance: 1.5,
                });
                rules.push(coinRules);
                break;
        }
        return rules;
    }
}
